import { Component, OnInit, ViewContainerRef, QueryList, ViewChildren, ComponentFactoryResolver, EventEmitter, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadCrumbsService } from '@services/bread-crumbs/bread-crumbs.service';
import { SplitAreaDirective } from 'angular-split';
import { FormRouteController } from '../../controllers/FormRouteController';
import { NestedNavigationService } from '../../../services/nested-navigation/nested-navigation.service';
import { IEntityOptions, IFormOptions } from '../../interfaces/IEntity';
import { ToolbarActionsService } from '../../../services/toolbar-actions/toolbar-actions.service';

export interface IBladeForm {
  displayName: string;
  component?: any;
  index: number;
  width?: number;
  hideClose?: boolean;
  showOnlyIfIdInUrl?: boolean;
  originalWidth?: number;
  autoMinimise?: boolean;
  minimiseWhenLowerThanIndex?: number;
  entityOptions?: IEntityOptions;
  formOnly?: boolean;
  formOptions?: IFormOptions;
  gridOptions?: IFormOptions;
  noBreadcrumb?: boolean;
  panelClass?: any;
  hideSideMenu?: boolean;
  loadFormWithoutParams?: boolean;
  breadCrumbIndex?: number;
  customAfterCommand?: Function;
}

@Component({
  selector: 'app-mf-blade-forms',
  templateUrl: './mf-blade-forms.component.html',
  styleUrls: ['./mf-blade-forms.component.css']
})
export class MfBladeFormsComponent extends FormRouteController implements OnInit {
  constructor(ApiService: ApiService,
    authService: IdentityAuthService,
    router: Router,
    route: ActivatedRoute,
    componentFactoryResolver: ComponentFactoryResolver,
    breadCrumbService: BreadCrumbsService,
    nestedNavigationService: NestedNavigationService,
    toolbarActionService?: ToolbarActionsService) {
    super(ApiService, authService, router, route, componentFactoryResolver, breadCrumbService, nestedNavigationService, toolbarActionService);
  }
}
